/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Link, TextField } from '@bingads-webui-campaign-react/xandr-video-campaign-shared-components';
import { FontIcon, Text } from '@bingads-webui-react/fabric-control';

export const Pagination = ({
  totalPages,
  disablePagination,
  classes,
  goToPrevPage,
  goToNextPage,
  goToPage,
  currentPageIndex,
}) => {
  const i18n = useContext(I18nContext);

  return (
    <>
      {totalPages > 1 && !disablePagination && (
        <div className={classes.pagination}>
          <div className={classes.pageControls}>
            <Link
              onClick={goToPrevPage}
              disabled={currentPageIndex <= 1}
            >
              <FontIcon iconName="ChevronLeft" /> <Text> Prev </Text>
            </Link>
            <TextField
              styles={{ root: { width: 40 } }}
              value={currentPageIndex}
              onChange={(e, val) => goToPage(val)}
            />
            <span> {i18n.getString(_TL_('of'))} {totalPages} </span>
            <Link
              onClick={goToNextPage}
              disabled={currentPageIndex === totalPages}
            >
              <Text> {i18n.getString(_TL_('Next'))} </Text> <FontIcon iconName="ChevronRight" />
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  disablePagination: PropTypes.bool,
  classes: PropTypes.shape({
    pagination: PropTypes.shape({}).isRequired,
    pageControls: PropTypes.shape({}).isRequired,
  }).isRequired,
  goToPrevPage: PropTypes.func.isRequired,
  goToNextPage: PropTypes.func.isRequired,
  goToPage: PropTypes.func.isRequired,
  currentPageIndex: PropTypes.number.isRequired,
};

Pagination.defaultProps = {
  disablePagination: false,
};
